import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../../components/VizComponents/Utils/connectFirebase";
import { v4 as uuidv4 } from "uuid";

export default function UploadImage({
  ControllerProps,
  currentSheet,
  dispatchItemToredux,
}) {
  const { reduxKey } = ControllerProps;

  const [imageUpload, setImageUpload] = useState(null);
  const [fileName, setFileName] = useState("No file chosen"); // To display the file name

  const uploadFile = (file) => {
    if (file == null) return;
    const imageRef = ref(storage, `images/${file.name + uuidv4()}`);

    uploadBytes(imageRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        // Dispatch the image URL to Redux
        dispatchItemToredux(url, reduxKey);
      });
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setImageUpload(file); // Store the selected file in state
      setFileName(file.name); // Set the file name to display
      uploadFile(file); // Automatically upload the file
    }
  };

  return (
    <div className="flex flex-col items-center w-full justify-start gap-2">
      {/* Custom button */}
      <label
        htmlFor="fileInput"
        className="px-2 py-1 bg-blue-950 text-white rounded cursor-pointer w-full"
      >
        Choose File
      </label>
      {/* Hidden file input */}
      <input
        id="fileInput"
        type="file"
        onChange={handleFileChange}
        className="hidden"
      />
      {/* Display selected file name */}
      <span className="text-gray-500 w-full text-left">{fileName}</span>
    </div>
  );
}
